export const Const_LaunchSmart = 'launch-smart';
//# sourceMappingURL=consts.js.map